import logger from '@/services/logger'
import { Taber } from 'shared'

const taber = new Taber(logger)

export default taber
